module.exports = __webpack_public_path__ + "img/location.6ee15a94.svg";